import useAuthState from '@/states/auth.state';
import { env } from '@/utils/constants/env';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const Login: React.FC = () => {
  const { handleLogin } = useAuthState();
  const [searchParams] = useSearchParams();
  const tenantId = searchParams.get('tenantId');
  const redirectTo = searchParams.get('redirect_to');

  useEffect(() => {
    localStorage.setItem('initial-tenant-id', tenantId!);
    if (redirectTo) {
      localStorage.setItem('redirect_to', redirectTo);
    }
    handleLogin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAuthMessage = () => {
    return env.authMethod === 'keycloak' ? 'Authenticating with Keycloak...' : 'Authenticating To AOS ONLINE';
  };

  return <div className="flex items-center justify-center h-screen bg-gray-100">{getAuthMessage()}</div>;
};
